const CRO_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!customElements.get('cro-hero-slider')) {
  customElements.define(
    'cro-hero-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cro-hero2__track');
        this.slides = Array.from(this.querySelectorAll('.cro-hero2__slide'));
        this.dots = Array.from(this.querySelectorAll('.cro-hero2__dot'));
        this.index = 0;
        if (CRO_REDUCED_MOTION.matches) this.track.style.transition = 'none';
        this.querySelector('.cro-hero2__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('.cro-hero2__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.addEventListener('touchstart', (e) => {
          this.swipeX = e.touches[0].clientX;
          this.swipeY = e.touches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (this.swipeX == null) return;
          const dx = e.changedTouches[0].clientX - this.swipeX;
          const dy = e.changedTouches[0].clientY - this.swipeY;
          this.swipeX = null;
          if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
        this.update();
      }

      go(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.update();
      }

      update() {
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== this.index);
          slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      }
    }
  );
}

if (!customElements.get('cro-text-rotator')) {
  customElements.define(
    'cro-text-rotator',
    class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.cro-hero2__rotate-item'));
        this.current = 0;
        this.items.forEach((item, i) => item.classList.toggle('is-cro-active', i === 0));
        if (this.items.length > 1 && !CRO_REDUCED_MOTION.matches) this.start();
      }

      start() {
        if (!this.timer) this.timer = setInterval(() => this.advance(), 3300);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      disconnectedCallback() {
        this.stop();
      }

      advance() {
        const prev = this.items[this.current];
        this.current = (this.current + 1) % this.items.length;
        const next = this.items[this.current];
        prev.classList.remove('is-cro-active');
        prev.classList.add('is-cro-leaving');
        setTimeout(() => prev.classList.remove('is-cro-leaving'), 500);
        next.classList.add('is-cro-active');
      }
    }
  );
}
